import { render, staticRenderFns } from "./SingleEmojiEditor.vue?vue&type=template&id=5d2cbcfa&"
import script from "./SingleEmojiEditor.vue?vue&type=script&lang=js&"
export * from "./SingleEmojiEditor.vue?vue&type=script&lang=js&"
import style0 from "./SingleEmojiEditor.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SingleEmojiEditor.vue"
export default component.exports